import { createAction, props } from '@ngrx/store';
import { IDataAction } from '../../utils/interfaces/common.interfaces';
import { ICreateInsightsOrder, ICreateLicensesOrder, IGetLicenseInfo, IOrdedLicenses, ISetSubscription, IValidateLicenses } from '../../utils/interfaces/remote-maintenance.interfaces';
import { AnnotatedOrder, DealerRemoteMaintenanceOrder, DeviceSubscriptionOfferExt, InsightsOffer, InsightsTierOrder, ManualSubscription, OrderItemStatus, SubscriptionDetails } from '../../generated/CrossPoint.License.Server/model/models'
import { IManualSubscriptionState } from 'src/app/utils/interfaces/store.interfaces';
import { ApiPermissions } from 'src/app/utils/interfaces/auth.interfaces';

export enum LicensesActionsTypes {
  ADD_LICENSE_SHOPPING_BASKET = '[LICENSES] ADD_LICENSE_SHOPPING_BASKET',
  ADD_LICENSE_SHOPPING_BASKET_SUCCESS = '[LICENSES] ADD_LICENSE_SHOPPING_BASKET_SUCCESS',
  ADD_LICENSE_SHOPPING_BASKET_FAILED = '[LICENSES] ADD_LICENSE_SHOPPING_BASKET_FAILED',

  CLEAR_SHOPPING_BASKET = '[LICENSES] CLEAR_SHOPPING_BASKET',
  CLEAR_SHOPPING_BASKET_SUCCESS = '[LICENSES] CLEAR_SHOPPING_BASKET_SUCCESS',
  CLEAR_SHOPPING_BASKET_FAILED = '[LICENSES] CLEAR_SHOPPING_BASKET_FAILED',

  CREATE_LICENSE_ORDER = '[LICENSES] CREATE_ORDER',
  CREATE_LICENSE_ORDER_SUCCESS = '[LICENSES] CREATE_ORDER_SUCCESS',
  CREATE_LICENSE_ORDER_FAILED = '[LICENSES] CREATE_ORDER_FAILED',

  GET_ACTIVE_LICENSES_INFO = '[LICENSES] GET_ACTIVE_LICENSES_INFO',
  GET_ACTIVE_LICENSES_INFO_SUCCESS = '[LICENSES] GET_ACTIVE_LICENSES_INFO_SUCCESS',
  GET_ACTIVE_LICENSES_INFO_FAILED = '[LICENSES] GET_ACTIVE_LICENSES_INFO_FAILED',

  GET_LICENSES_DETAILS_INFO = '[LICENSES] GET_LICENSES_DETAILS_INFO',
  GET_LICENSES_DETAILS_INFO_SUCCESS = '[LICENSES] GET_LICENSES_DETAILS_INFO_SUCCESS',
  GET_LICENSES_DETAILS_INFO_FAILED = '[LICENSES] GET_LICENSES_DETAILS_INFO_FAILED',

  GET_EXPIRING_LICENSES_INFO = '[LICENSES] GET_EXPIRING_LICENSES_INFO',
  GET_EXPIRING_LICENSES_INFO_SUCCESS = '[LICENSES] GET_EXPIRING_LICENSES_INFO_SUCCESS',
  GET_EXPIRING_LICENSES_INFO_FAILED = '[LICENSES] GET_EXPIRING_LICENSES_INFO_FAILED',

  GET_EXPIRED_LICENSES_INFO = '[LICENSES] GET_EXPIRED_LICENSES_INFO',
  GET_EXPIRED_LICENSES_INFO_SUCCESS = '[LICENSES] GET_EXPIRED_LICENSES_INFO_SUCCESS',
  GET_EXPIRED_LICENSES_INFO_FAILED = '[LICENSES] GET_EXPIRED_LICENSES_INFO_FAILED',

  GET_LOCAL_STORAGE_SHOPPING_BASKET = '[LICENSES] GET_LOCAL_STORAGE_SHOPPING_BASKET',
  GET_LOCAL_STORAGE_SHOPPING_BASKET_SUCCESS = '[LICENSES] GET_LOCAL_STORAGE_SHOPPING_BASKET_SUCCESS',
  GET_LOCAL_STORAGE_SHOPPING_BASKET_FAILED = '[LICENSES] GET_LOCAL_STORAGE_SHOPPING_BASKET_FAILED',

  REMOVE_LICENSE_SHOPPING_BASKET = '[LICENSES] REMOVE_LICENSE_SHOPPING_BASKET',
  REMOVE_LICENSE_SHOPPING_BASKET_SUCCESS = '[LICENSES] REMOVE_LICENSE_SHOPPING_BASKET_SUCCESS',
  REMOVE_LICENSE_SHOPPING_BASKET_FAILED = '[LICENSES] REMOVE_LICENSE_SHOPPING_BASKET_FAILED',

  UPDATE_LICENSE_SHOPPING_BASKET = '[LICENSES] UPDATE_LICENSE_SHOPPING_BASKET',
  UPDATE_LICENSE_SHOPPING_BASKET_SUCCESS = '[LICENSES] UPDATE_LICENSE_SHOPPING_BASKET_SUCCESS',
  UPDATE_LICENSE_SHOPPING_BASKET_FAILED = '[LICENSES] UPDATE_LICENSE_SHOPPING_BASKET_FAILED',

  VALIDATE_LICENSES = '[LICENSES] VALIDATE_LICENSES',
  VALIDATE_LICENSES_SUCCESS = '[LICENSES] VALIDATE_LICENSES_SUCCESS',
  VALIDATE_LICENSES_FAILED = '[LICENSES] VALIDATE_LICENSES_FAILED',

  GET_ORDERS = '[LICENSES] GET_ORDED_LICENSES',
  GET_ORDERS_SUCCESS = '[LICENSES] GET_ORDED_LICENSES_SUCCESS',
  GET_ORDERS_FAILED = '[LICENSES] GET_ORDED_LICENSES_FAILED',

  GET_ORDER = '[LICENSES] GET_ORDER_LICENSES',
  GET_ORDER_SUCCESS = '[LICENSES] GET_ORDER_LICENSES_SUCCESS',
  GET_ORDER_FAILED = '[LICENSES] GET_ORDER_LICENSES_FAILED',

  SET_SUBSCRIPTION = '[LICENSES] SET_SUBSCIPTION',
  SET_SUBSCRIPTION_SUCCESS = '[LICENSES] SET_SUBSCIPTION_SUCCESS',
  SET_SUBSCRIPTION_FAILED = '[LICENSES] SET_SUBSCIPTION_FAILED',

  GET_SUBSCRIPTION = '[LICENSES] GET_SUBSCIPTION',
  GET_SUBSCRIPTION_SUCCESS = '[LICENSES] GET_SUBSCIPTION_SUCCESS',
  GET_SUBSCRIPTION_FAILED = '[LICENSES] GET_SUBSCIPTION_FAILED',

  GET_AUTH_INFO_LICENSES = '[AUTH] AUTH_INFO_LICENSES',
  GET_AUTH_INFO_LICENSES_SUCCESS = '[AUTH] AUTH_INFO_LICENSES_SUCCESS',
  GET_AUTH_INFO_LICENSES_FAILED = '[AUTH] AUTH_INFO_LICENSES_FAILED',

  GET_INSIGHTS_OFFERS = '[LICENSES] GET_INSIGHTS_OFFERS',
  GET_INSIGHTS_OFFERS_SUCCESS = '[LICENSES] GET_INSIGHTS_OFFERS_SUCCESS',
  GET_INSIGHTS_OFFERS_FAILED = '[LICENSES] GET_INSIGHTS_OFFERS_FAILED',

  CREATE_INSIGHTS_ORDER = '[LICENSES] CREATE_INSIGHTS_ORDER',
  CREATE_INSIGHTS_ORDER_SUCCESS = '[LICENSES] CREATE_INSIGHTS_ORDER_SUCCESS',
  CREATE_INSIGHTS_ORDER_FAILED = '[LICENSES] CREATE_INSIGHTS_ORDER_FAILED',
}

export const addLicenseToShoppingBasketAction = createAction(LicensesActionsTypes.ADD_LICENSE_SHOPPING_BASKET, props<IDataAction<DeviceSubscriptionOfferExt>>());
export const addLicenseToShoppingBasketSuccessAction = createAction(LicensesActionsTypes.ADD_LICENSE_SHOPPING_BASKET_SUCCESS, props<IDataAction<DeviceSubscriptionOfferExt>>());
export const addLicenseToShoppingBasketFailedAction = createAction(LicensesActionsTypes.ADD_LICENSE_SHOPPING_BASKET_FAILED);

export const clearShoppingBasketAction = createAction(LicensesActionsTypes.CLEAR_SHOPPING_BASKET);
export const clearShoppingBasketSuccessAction = createAction(LicensesActionsTypes.CLEAR_SHOPPING_BASKET_SUCCESS);
export const clearShoppingBasketFailedAction = createAction(LicensesActionsTypes.CLEAR_SHOPPING_BASKET_FAILED);

export const createLicensesOrderAction = createAction(LicensesActionsTypes.CREATE_LICENSE_ORDER, props<IDataAction<ICreateLicensesOrder>>());
export const createLicensesOrderSuccessAction = createAction(LicensesActionsTypes.CREATE_LICENSE_ORDER_SUCCESS, props<IDataAction<DealerRemoteMaintenanceOrder>>());
export const createLicensesOrderFailedAction = createAction(LicensesActionsTypes.CREATE_LICENSE_ORDER_FAILED);

export const getLicensesDetailsInfoAction = createAction(LicensesActionsTypes.GET_LICENSES_DETAILS_INFO, props<IDataAction<string>>());
export const getLicensesDetailsInfoSuccessAction = createAction(LicensesActionsTypes.GET_LICENSES_DETAILS_INFO_SUCCESS, props<IDataAction<SubscriptionDetails>>());
export const getLicensesDetailsInfoFailedAction = createAction(LicensesActionsTypes.GET_LICENSES_DETAILS_INFO_FAILED);

export const getActiveLicensesInfoAction = createAction(LicensesActionsTypes.GET_ACTIVE_LICENSES_INFO, props<IDataAction<IGetLicenseInfo>>());
export const getActiveLicensesInfoSuccessAction = createAction(LicensesActionsTypes.GET_ACTIVE_LICENSES_INFO_SUCCESS, props<IDataAction<DeviceSubscriptionOfferExt[]>>());
export const getActiveLicensesInfoFailedAction = createAction(LicensesActionsTypes.GET_ACTIVE_LICENSES_INFO_FAILED);

export const getExpiringLicensesInfoAction = createAction(LicensesActionsTypes.GET_EXPIRING_LICENSES_INFO, props<IDataAction<IGetLicenseInfo>>());
export const getExpiringLicensesInfoSuccessAction = createAction(LicensesActionsTypes.GET_EXPIRING_LICENSES_INFO_SUCCESS, props<IDataAction<DeviceSubscriptionOfferExt[]>>());
export const getExpiringLicensesInfoFailedAction = createAction(LicensesActionsTypes.GET_EXPIRING_LICENSES_INFO_FAILED);

export const getExpiredLicensesInfoAction = createAction(LicensesActionsTypes.GET_EXPIRED_LICENSES_INFO, props<IDataAction<IGetLicenseInfo>>());
export const getExpiredLicensesInfoSuccessAction = createAction(LicensesActionsTypes.GET_EXPIRED_LICENSES_INFO_SUCCESS,props<IDataAction<DeviceSubscriptionOfferExt[]>>());
export const getExpiredLicensesInfoFailedAction = createAction(LicensesActionsTypes.GET_EXPIRED_LICENSES_INFO_FAILED);

export const getLicensesLocalStorageAction = createAction(LicensesActionsTypes.GET_LOCAL_STORAGE_SHOPPING_BASKET);

export const getLicensesLocalStorageSuccessAction = createAction(LicensesActionsTypes.GET_LOCAL_STORAGE_SHOPPING_BASKET_SUCCESS, props<IDataAction<DeviceSubscriptionOfferExt[]>>());
export const getLicensesLocalStorageFailedAction = createAction(LicensesActionsTypes.GET_LOCAL_STORAGE_SHOPPING_BASKET_FAILED);

export const removeLicenseFromShoppingBasketAction = createAction(LicensesActionsTypes.REMOVE_LICENSE_SHOPPING_BASKET, props<IDataAction<DeviceSubscriptionOfferExt>>());
export const removeLicenseFromShoppingBasketSuccessAction = createAction(LicensesActionsTypes.REMOVE_LICENSE_SHOPPING_BASKET_SUCCESS, props<IDataAction<DeviceSubscriptionOfferExt>>());
export const removeLicenseFromShoppingBasketFailedAction = createAction(LicensesActionsTypes.REMOVE_LICENSE_SHOPPING_BASKET_FAILED);

export const updateLicensesShoppingBasketAction = createAction(LicensesActionsTypes.UPDATE_LICENSE_SHOPPING_BASKET, props<IDataAction<DeviceSubscriptionOfferExt[]>>());
export const updateLicensesShoppingBasketSuccessAction = createAction(LicensesActionsTypes.UPDATE_LICENSE_SHOPPING_BASKET_SUCCESS, props<IDataAction<DeviceSubscriptionOfferExt[]>>());
export const updateLicensesShoppingBasketFailedAction = createAction(LicensesActionsTypes.UPDATE_LICENSE_SHOPPING_BASKET_FAILED);

export const validateLicensesAction = createAction(LicensesActionsTypes.VALIDATE_LICENSES, props<IDataAction<IValidateLicenses>>());
export const validateLicensesSuccessAction = createAction(LicensesActionsTypes.VALIDATE_LICENSES_SUCCESS, props<IDataAction<OrderItemStatus[]>>());
export const validateLicensesFailedAction = createAction(LicensesActionsTypes.VALIDATE_LICENSES_FAILED);

export const getOrdersAction = createAction(LicensesActionsTypes.GET_ORDERS, props<IDataAction<IOrdedLicenses>>());
export const getOrdersSuccessAction = createAction(LicensesActionsTypes.GET_ORDERS_SUCCESS, props<IDataAction<DealerRemoteMaintenanceOrder[]>>());
export const getOrdersFailedAction = createAction(LicensesActionsTypes.GET_ORDERS_FAILED);

export const getOrderAction = createAction(LicensesActionsTypes.GET_ORDER, props<IDataAction<string>>());
export const getOrderSuccessAction = createAction(LicensesActionsTypes.GET_ORDER_SUCCESS, props<IDataAction<AnnotatedOrder>>());
export const getOrderFailedAction = createAction(LicensesActionsTypes.GET_ORDER_FAILED);

export const setSubscriptionAction = createAction(LicensesActionsTypes.SET_SUBSCRIPTION, props<IDataAction<ISetSubscription>>());
export const setSubscriptionSuccessAction = createAction(LicensesActionsTypes.SET_SUBSCRIPTION_SUCCESS);
export const setSubscriptionFailedAction = createAction(LicensesActionsTypes.SET_SUBSCRIPTION_FAILED);

export const getSubscriptionAction = createAction(LicensesActionsTypes.GET_SUBSCRIPTION, props<IDataAction<string>>());
export const getSubscriptionSuccessAction = createAction(LicensesActionsTypes.GET_SUBSCRIPTION_SUCCESS, props<IDataAction<IManualSubscriptionState>>());
export const getSubscriptionFailedAction = createAction(LicensesActionsTypes.GET_SUBSCRIPTION_FAILED);

export const getAuthInfoLicensesAction = createAction(LicensesActionsTypes.GET_AUTH_INFO_LICENSES);
export const getAuthInfoLicensesSuccessAction = createAction(LicensesActionsTypes.GET_AUTH_INFO_LICENSES_SUCCESS, props<IDataAction<ApiPermissions>>());
export const getAuthInfoLicensesFailedAction = createAction(LicensesActionsTypes.GET_AUTH_INFO_LICENSES_FAILED);

export const getInsightsOffersAction = createAction(LicensesActionsTypes.GET_INSIGHTS_OFFERS, props<IDataAction<string>>());
export const getInsightsOffersSuccessAction = createAction(LicensesActionsTypes.GET_INSIGHTS_OFFERS_SUCCESS, props<IDataAction<InsightsOffer[]>>());
export const getInsightsOffersFailedAction = createAction(LicensesActionsTypes.GET_INSIGHTS_OFFERS_FAILED, props<IDataAction<string>>());

export const createInsightsOrderAction = createAction(LicensesActionsTypes.CREATE_INSIGHTS_ORDER, props<IDataAction<ICreateInsightsOrder>>());
export const createInsightsOrderSuccessAction = createAction(LicensesActionsTypes.CREATE_INSIGHTS_ORDER_SUCCESS, props<IDataAction<InsightsTierOrder>>());
export const createInsightsOrderFailedAction = createAction(LicensesActionsTypes.CREATE_INSIGHTS_ORDER_FAILED, props<IDataAction<ICreateInsightsOrder>>());